/// <amd-module name="Artifacts/Connect/redux/Module" />
import { IConnectToFeedContainerOwnState } from "Artifacts/Connect/redux/Contracts";
import { connectToFeedReducer } from "Artifacts/Connect/redux/Reducers";
import rootSaga from "Artifacts/Connect/redux/Sagas";
import { ISagaModule } from "redux-dynamic-modules-saga";
import { VSSPageDataModule } from "VSS/Redux/Modules/VSSPageData";

const ConnectToFeedModule: ISagaModule<IConnectToFeedContainerOwnState> = {
  id: "feed-connect-to-feed",
  reducerMap: {
    connectToFeed: connectToFeedReducer,
  },
  sagas: [rootSaga],
};

export function getConnectToFeedModule() {
  return [VSSPageDataModule, ConnectToFeedModule];
}
